import * as React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import { useTheme } from '@mui/material/styles'

export default function Loader() {
  const theme = useTheme()

  return (
    <div
      style={{
        position: 'fixed',
        display: 'flex',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 99999,
        width: '100vw',
        height: '100vh',
        alignItems: 'center',
        justifyItems: 'center',
        pointerEvents: 'none',
        cursor: 'default',
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: 0,
          right: 0,
          width: '100vw',
          height: '100vh',
          backgroundColor: theme.palette.grey[500],
          opacity: 0.5,
        }}
      />

      <CircularProgress size={80} style={{ flex: '0 0 auto', marginLeft: 'auto', marginRight: 'auto' }} />
    </div>
  )
}
